<template>
  <v-dialog v-model="modalAberto" max-width="500px">
    <v-card>
      <v-card-title class="headline">Detalhes do Evento</v-card-title>

      <v-card-text v-if="eventoSelecionado">
        <v-row>
          <v-col cols="12" class="pb-1">
            <strong>Categoria:</strong>
            <v-chip class="ml-2" :color="eventoSelecionado.color" dark small>
              {{ eventoSelecionado.name || "Sem Categoria" }}
            </v-chip>
          </v-col>
          <v-col cols="12" class="py-1">
            <strong>Data:</strong> {{ formatarData(eventoSelecionado.start) || "Não informado" }}
          </v-col>
          <v-col cols="12" class="py-1">
            <strong>Descrição:</strong> {{ eventoSelecionado.descricao || "Não informado" }}
          </v-col>
          <v-col cols="12" class="py-1">
            <strong>É Feriado / Recesso:</strong>
            <v-chip
              class="ml-2"
              :color="eventoSelecionado.is_feriado ? 'error' : 'grey'"
              dark
              x-small
            >
              {{ eventoSelecionado.is_feriado ? "SIM" : "NÃO" }}
            </v-chip>
          </v-col>
          <v-col cols="12" class="pt-1">
            <strong>Sábado de Trabalho:</strong>
            <v-chip
              class="ml-2"
              :color="eventoSelecionado.is_sabado_letivo ? 'success' : 'grey'"
              dark
              x-small
            >
              {{ eventoSelecionado.is_sabado_letivo ? "SIM" : "NÃO" }}
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="fecharModal">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modalAberto: {
      type: Boolean,
      required: true,
    },
    eventoSelecionado: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatarData(data) {
      if (!data) return "";
      const date = new Date(data);
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
      return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
    },
    fecharModal() {
      this.$emit("fechar-modal");
    },
  },
};
</script>

<style scoped></style>
